<div class="row" style="min-height: 700px;">
  @if (!isActivatorClinic) {
    <div class="col-xs-2 navContainer">
      <div [id]="identifierService.labelId('viewEditPatientProfile', 'demographics')" class="h6 ml-10 mb-15">{{ 'label.gb.pat_prof' | translate }}</div>
      @for (sideLink of sideBarLinks; track sideLink) {
        <div
          matRipple [matRippleColor]="rippleColor"
          [ngClass]="{navLinkSelected: mySectionSelected(sideLink.link), navLink: !mySectionSelected(sideLink.link)}"
          (click)="setSection(sideLink.link, sideLink.label)"
          [id]="identifierService.labelId('viewEditProfile', 'sideLink_' + sideLink.link)"
          [innerHTML]="sideLink.label"
        ></div>
      }
    </div>
  }
  <div class="workspace"  [ngClass]="{'col-xs-12':isActivatorClinic,'col-xs-10':!isActivatorClinic}">
    @if (showYellowCard) {
      <div class="yellowCard">This is where the transfer request will be displayed</div>
    }
    @if (mySectionSelected('patient-&-device-data')) {
      <app-manual-patient-device-data
        functionMode='profile'
        [patientid]="patientId"
        (setPatientHeader)="setPatientHeader($event)"
        (setSubMenu)="getSubMenu($event)"
      ></app-manual-patient-device-data >
    }
    @if (mySectionSelected('transmitter')) {
      <app-enroll-patient-transmitter
        [patientid]="patientId"
        functionMode='profile'
      ></app-enroll-patient-transmitter>
    }
    @if (mySectionSelected('follow-up-schedule')) {
      <app-followup-schedule [patientid]="patientId" functionMode='profile'></app-followup-schedule>
    }
    @if (mySectionSelected('direct-alerts-notifications')) {
      <app-direct-alerts-notifications [patientId]="patientId" functionMode="profile"></app-direct-alerts-notifications>
    }
    @if (mySectionSelected('baseline-clinical-data')) {
      <app-baseline-clinical-data [patientid]="patientId" functionMode='profile'></app-baseline-clinical-data>
    }
  </div>
</div>
